/*
 * Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    pageContainer: { minHeight: `calc(100vh - 64px)` },
    text: { fontSize: '40px' },
    directVisitWarningTitle: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      lineHeight: 1.8,
    },
    directVisitWarningDescription: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      lineHeight: 1.8,
    },
  })
);
